import { CSSObject } from '@emotion/core';

import { themeColor } from '@scripts/themes/cssVars';

import { scrollbarStyles } from '../../../../styles';

export const popupBodyStyles: CSSObject = {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    position: 'relative',
};

export const loaderOverlayStyles: CSSObject = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    backgroundColor: themeColor.white,
    opacity: 0.8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const scrollableContainerStyles: CSSObject = {
    padding: '0 16px 16px',
    overflowY: 'auto',
    flex: 1,
    minHeight: 0,
    maxHeight: 'none',
    ...scrollbarStyles.wide,
};

export const mobileRootStyles: CSSObject = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    height: '100%',
};
